import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import { Sparkles } from 'lucide-react';
import KnowledgePackagePanel from '@/components/KnowledgePackagePanel';

// AI Explore knowledge portability — share the business glossary, value
// synonyms, learned query patterns and golden Q&A between customers. On import
// the admin maps everything onto a target semantic model on this server.
export default function KnowledgeTab({ active }) {
  const [models, setModels] = useState([]);

  useEffect(() => {
    if (!active) return;
    (async () => {
      try {
        const res = await api.getSemanticModels();
        const list = Array.isArray(res) ? res : (res.models || res.items || []);
        setModels(list.map((m) => ({ model_id: m.model_id || m.id, name: m.display_name || m.name || m.model_id })));
      } catch (e) {
        toast.error('Failed to load semantic models');
      }
    })();
  }, [active]);

  return (
    <div className="space-y-4 max-w-2xl" data-testid="knowledge-tab">
      <KnowledgePackagePanel
        testIdPrefix="explore-knowledge"
        icon={Sparkles}
        kind="explore"
        title="AI Explore knowledge package"
        description="Export what your AI Explore has been taught — business glossary, value synonyms, learned query patterns and golden Q&A — as a portable file to share with other customers. On import, choose which semantic model on this server to teach."
        filenameBase="ai-explore-knowledge"
        models={models}
        exportFn={(note) => api.exportExploreKnowledge(note)}
        importFn={(pkg, modelId, include) => api.importExploreKnowledge(pkg, modelId, include)}
      />
      <p className="text-xs text-muted-foreground">
        Learned patterns and value synonyms are re-mapped onto the target model you pick. Glossary terms that weren&apos;t tied to a model stay workspace-wide. Import is additive — nothing is overwritten or deleted.
      </p>
    </div>
  );
}
